import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieBanner from "./CookieBanner";

export default function Layout({ children, noFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col bg-ivory text-ink">
      <Header />
      <main className="flex-1 page-enter">{children}</main>
      {!noFooter && <Footer />}
      <CookieBanner />
    </div>
  );
}
